var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _vm.checkBtn
      ? _c(
          "div",
          [
            _c("el-card", { staticClass: "normal-page p20" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "flex-between" },
                  [
                    _c("div", { staticClass: "title-16" }, [
                      _vm._v("假期类型"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-plus",
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addType()
                          },
                        },
                      },
                      [_vm._v("新增")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "total-16 mt20" }, [
                  _vm._v("共有 " + _vm._s(_vm.total) + " 条"),
                ]),
                _vm._v(" "),
                _vm.tableData.length > 0
                  ? _c(
                      "div",
                      { staticClass: "mt14" },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.tableData,
                              height: _vm.tableHeight,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "假期类型",
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", { staticClass: "flex" }, [
                                          _c("div", { staticClass: "ml10" }, [
                                            _vm._v(_vm._s(scope.row.name)),
                                          ]),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2117175629
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "refuse",
                                label: "请假单位",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.duration_type == 1
                                                ? "按小时"
                                                : "按天"
                                            )
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2435576155
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "sort", label: "排序" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "操作", width: "200" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "business:examine:index:edit",
                                                ],
                                                expression:
                                                  "['business:examine:index:edit']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("public.edit"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "business:examine:index:delete",
                                                ],
                                                expression:
                                                  "['business:examine:index:delete']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("public.delete"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2084800080
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-fixed" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "page-size": _vm.where.limit,
                                "current-page": _vm.where.page,
                                "page-sizes": [15, 20, 30],
                                layout:
                                  "total,sizes, prev, pager, next, jumper",
                                total: _vm.total,
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.pageChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("default-page", {
                          directives: [{ name: "height", rawName: "v-height" }],
                          attrs: { index: 14, "min-height": 520 },
                        }),
                      ],
                      1
                    ),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.checkBtn
      ? _c("div", { staticClass: "examineBox" }, [
          _c(
            "div",
            { staticClass: "mt20 card-box" },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "examineCard" }, [
                  _c("i", {
                    staticClass: "el-icon-arrow-left",
                    on: { click: _vm.back },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(this.id > 0 ? "编辑" : "添加") + "假期类型"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "setting-container mt14" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                          _vm._v(" "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          _vm._b({}, "el-col", _vm.grid2, false),
                          [
                            _c(
                              "el-form",
                              {
                                ref: "elForm",
                                attrs: {
                                  model: _vm.form,
                                  rules: _vm.rules,
                                  size: "medium",
                                  "label-width": "150px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "card-list" },
                                  [
                                    _c("div", { staticClass: "head" }, [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v("基础信息设置"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "假期类型：",
                                          prop: "name",
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "350px" },
                                          attrs: {
                                            size: "small",
                                            "show-word-limit": "",
                                            placeholder: "请输入假期类型",
                                            clearable: "",
                                          },
                                          model: {
                                            value: _vm.form.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "name", $$v)
                                            },
                                            expression: "form.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-bottom": "0" },
                                        attrs: {
                                          label: "新员工请假：",
                                          prop: "new_employee_limit",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "350px" },
                                            attrs: { size: "small" },
                                            model: {
                                              value:
                                                _vm.form.new_employee_limit,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "new_employee_limit",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.new_employee_limit",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "限制",
                                                value: 1,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                label: "不限制",
                                                value: 0,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "infos" }, [
                                      _vm.form.new_employee_limit == 0
                                        ? _c("span", { staticClass: "info" }, [
                                            _vm._v("入职即可请假"),
                                          ])
                                        : _c(
                                            "div",
                                            [
                                              _vm._v(
                                                "\n                      入职时长小于\n                      "
                                              ),
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100px",
                                                    "margin-top": "10px",
                                                  },
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value:
                                                      _vm.form
                                                        .new_employee_limit_month,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "new_employee_limit_month",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.new_employee_limit_month",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.months,
                                                  function (month) {
                                                    return _c("el-option", {
                                                      key: month,
                                                      attrs: {
                                                        label: month,
                                                        value: month,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              _vm._v(
                                                "\n                      个月时，不可申请此假期\n                    "
                                              ),
                                            ],
                                            1
                                          ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-list mt20" },
                                  [
                                    _c("div", { staticClass: "head" }, [
                                      _c("span", { staticClass: "title" }, [
                                        _vm._v("请假时长核算规则"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "请假时长：",
                                          prop: "duration_type",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "350px" },
                                            attrs: { size: "small" },
                                            model: {
                                              value: _vm.form.duration_type,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "duration_type",
                                                  $$v
                                                )
                                              },
                                              expression: "form.duration_type",
                                            },
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "按天",
                                                value: 0,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                label: "按小时",
                                                value: 1,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.form.duration_type == 1
                                          ? _c(
                                              "span",
                                              { staticClass: "info" },
                                              [
                                                _vm._v(
                                                  "审批申请按分钟请假，打卡月报按小时统计"
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "info" },
                                              [
                                                _vm._v(
                                                  "审批申请按半天请假，打卡月报按天统计"
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "排序：",
                                          prop: "sort",
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "350px" },
                                          attrs: {
                                            precision: 0,
                                            min: 0,
                                            "controls-position": "right",
                                            size: "small",
                                          },
                                          model: {
                                            value: _vm.form.sort,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "sort", $$v)
                                            },
                                            expression: "form.sort",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.checkBtn
      ? _c(
          "div",
          { staticClass: "cr-bottom-button btn-shadow" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    _vm.checkBtn = true
                  },
                },
              },
              [_vm._v("取消")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.save },
              },
              [_vm._v("保存")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }